import { SecurityPermissionName } from '@app/core/models/permission';
import { AuthUser } from './auth-user';

export enum UserLevel {
  EndUser = 'END_USER',
  EnterpriseAdmin = 'ENTERPRISE_ADMIN',
  ServiceProviderAdmin = 'SERVICE_PROVIDER_ADMIN',
  SystemAdmin = 'SYSTEM_ADMIN',
  All = 'ALL',
}

const UserLevelValue = {
  [UserLevel.All]: 0,
  [UserLevel.EndUser]: 1,
  [UserLevel.EnterpriseAdmin]: 2,
  [UserLevel.ServiceProviderAdmin]: 3,
  [UserLevel.SystemAdmin]: 4,
};

export function userLevelFromString(userLevel: string) {
  const level = userLevel.toLowerCase();
  let match: UserLevel;

  Object.entries(UserLevel).forEach(([key, value]: [string, UserLevel]) => {
    key = key.toLowerCase();

    if (key === level || key === level.replace(/_/g, '')) {
      match = value;
    }
  });

  if (match === undefined) {
    console.error(`Couldn't find a userLevel for string '${userLevel}'`);
  }

  return match;
}

export function userLevelIsEnough(userLevel: UserLevel, user: AuthUser | UserLevel) {
  let highEnough = true;

  const isAuthUser = (o: any): o is AuthUser => o?.role !== undefined;
  const valueUserLevel = UserLevelValue[userLevel];

  let valueUser;

  if (isAuthUser(user)) {
    const isSystemAdmin = user.role.permissions.includes(SecurityPermissionName.MANAGE_SYSTEM);

    if (isSystemAdmin) {
      valueUser = UserLevelValue[UserLevel.SystemAdmin];
    } else {
      valueUser = UserLevelValue[user.role.level];
    }
  } else {
    valueUser = UserLevelValue[user];
  }

  // The UserLevel value of the user has to be equal or greater than the value of the required UserLevel
  if (valueUserLevel !== undefined && valueUser !== undefined) {
    highEnough = valueUser >= valueUserLevel;
  }

  if (valueUser === undefined) {
    highEnough = false;
  }

  return highEnough;
}

export function isServiceProvider(user: AuthUser) {
  return userLevelIsEnough(UserLevel.ServiceProviderAdmin, user);
}

export function isEnterprise(user: AuthUser) {
  return userLevelIsEnough(UserLevel.EnterpriseAdmin, user);
}

export function isEndUser(user: AuthUser) {
  return userLevelIsEnough(UserLevel.EndUser, user);
}
